import React from "react";
import Breadcrumbs from "../components/Breadcrumbs";
import ContactForm from "../components/ContactForm";

const ContactPage = () => {
  return (
    <>
      <Breadcrumbs />
      <ContactForm />
    </>
  );
};

export default ContactPage;
